import IconCustomEnedis from '@/shared/icons/IconCustomEnedis'
import IconCarbonBadge from '@/shared/icons/IconCarbonBadge'
import IconCarbonThumbsUp from '@/shared/icons/IconCarbonThumbsUp'
import IconCarbonInformation from '@/shared/icons/IconCarbonInformation'
import IconCarbonCarbonAccounting from '@/shared/icons/IconCarbonCarbonAccounting'
import IconCustomAxa from '@/shared/icons/IconCustomAxa'
import IconCustomVoltalis from '@/shared/icons/IconCustomVoltalis'
import IconCarbonRule from '@/shared/icons/IconCarbonRule'
import IconCarbonSatelliteRadar from '@/shared/icons/IconCarbonSatelliteRadar'
import IconCarbonLightning from '@/shared/icons/IconCarbonLightning'
import IconCarbonHome from '@/shared/icons/IconCarbonHome'
import IconCarbonFinance from '@/shared/icons/IconCarbonFinance'
import IconCustomNextories from '@/shared/icons/IconCustomNextories'
import IconCarbonEventsAlt from '@/shared/icons/IconCarbonEventsAlt'
import IconCustomMesAllocs from '@/shared/icons/IconCustomMesAllocs'
import IconCarbonTwoPersonLift from '@/shared/icons/IconCarbonTwoPersonLift'
import IconCarbonToolKit from '@/shared/icons/IconCarbonToolKit'
import IconCarbonWater from '@/shared/icons/IconCarbonWater'
import IconCarbonMonConseillerPerso from '@/shared/icons/IconCarbonMonConseillerPerso'
import IconCarbonNotification from '@/shared/icons/IconCarbonNotification'
import IconCarbonHeadphones from '@/shared/icons/IconCarbonHeadphones'
import IconCarbonAirlinePassengerCare from '@/shared/icons/IconCarbonAirlinePassengerCare'
import IconCustomHomyos from '@/shared/icons/IconCustomHomyos'
import IconPhone from './NewDesign/IconPhone'
import IconBolt from './NewDesign/IconBolt'
import IconShieldPerson from './NewDesign/IconShieldPerson'
import IconCustomNeat from '@/shared/icons/IconCustomNeat'
import IconCustomCentury21 from '@/shared/icons/IconCustomCentury21'
import IconCustomEmoovz from '@/shared/icons/IconCustomEmoovz'
import IconCustomEazy from '@/shared/icons/IconCustomEazy'
import IconCustomVodafone from '@/shared/icons/IconCustomVodafone'
import IconCustomRetentionVa from '@/shared/icons/IconCustomRetentionVa'

/**
 * @param {string} name
 * @param {number} [size]
 * @param {object} [overrides]
 * @param {string | null} [color]
 */
const retrieveAdditionalSalesIcons = (name, size = 20, overrides, color = null) => {
  if (!name) {
    return null
  }
  switch (name) {
    case 'enedis-api':
      return <IconCustomEnedis size={size} color={color} overrides={overrides} />
    case 'reviews-status':
      return <IconCarbonThumbsUp size={size} color={color} overrides={overrides} />
    case 'sales-leadCarbonOffset':
    case 'leadCarbonOffset':
      return <IconCarbonCarbonAccounting color={color} size={size} overrides={overrides} />
    case 'sales-leadAssistance':
    case 'sales-leadAssistancePro':
    case 'saleAssistancePro':
    case 'sales-leadAxaSmartphone':
    case 'leadAssistance':
    case 'leadAssistancePro':
    case 'leadAxaSmartphone':
    case 'sales-leadAxaBillProtection':
    case 'leadAxaBillProtection':
      return <IconCustomAxa size={size} color={color} overrides={overrides} />
    case 'sales-leadVoltalisBizdev':
    case 'leadVoltalisBizdev':
    case 'sales-leadVoltalis':
      return <IconCustomVoltalis size={size} color={color} overrides={overrides} />
    case 'sales-leadNeat':
    case 'leadNeat':
      return <IconCustomNeat size={size} color={color} overrides={overrides} />
    case 'sales-leadCentury21':
    case 'leadCentury21':
      return <IconCustomCentury21 size={size} color={color} overrides={overrides} />
    case 'sales-leadEazy':
    case 'leadEazy':
      return <IconCustomEazy size={size} color={color} overrides={overrides} />
    case 'sales-leadVodafone':
    case 'leadVodafone':
      return <IconCustomVodafone size={size} color={color} overrides={overrides} />
    case 'sales-leadAssuranceDefault':
    case 'sales-leadAssurance':
    case 'sales-leadBankinAssurance':
    case 'sales-leadAssuranceProSante':
    case 'sales-leadYagoAssurance':
    case 'sales-leadYagoAssuranceHouse':
    case 'sales-leadYagoAssuranceCar':
    case 'sales-leadYagoAssuranceMoto':
    case 'sales-leadProtected':
    case 'sales-leadProtectedClub':
    case 'sales-leadAssurancePro':
    case 'leadAssuranceDefault':
    case 'leadAssurance':
    case 'leadBankinAssurance':
    case 'leadAssuranceProSante':
    case 'leadYagoAssurance':
    case 'leadYagoAssuranceHouse':
    case 'leadYagoAssuranceCar':
    case 'leadYagoAssuranceMoto':
    case 'leadProtected':
    case 'leadProtectedClub':
    case 'leadAssurancePro':
      return <IconCarbonRule size={size} color={color} overrides={overrides} />
    case 'sales-telecomSat':
    case 'sales-leadTelecom':
    case 'sales-leadTelecomLovys':
    case 'leadTelecomLovys':
    case 'leadTelecomSat':
    case 'leadTelecom':
      return <IconCarbonSatelliteRadar size={size} color={color} overrides={overrides} />
    case 'sales-telecomEnergy':
    case 'sales-leadEnergyProPlaceDesEnergies':
    case 'sales-leadEnergyProBtob':
    case 'sales-leadOffshoreTelecom':
    case 'leadTelecomEnergy':
    case 'leadEnergyProPlaceDesEnergies':
    case 'leadEnergyProBtob':
    case 'leadOffshoreTelecom':
      return <IconCarbonLightning size={size} color={color} overrides={overrides} />
    case 'sales-leadTucoenergie':
    case 'sales-leadEnergygo':
    case 'leadTucoenergie':
    case 'leadEnergygo':
      return <IconCarbonHome size={size} color={color} overrides={overrides} />
    case 'sales-leadEddyProprietaire':
    case 'sales-leadAssuranceEmprunteur':
    case 'sales-leadAssuranceEmprunteurMeilleurTaux':
    case 'sales-leadBankPanorabanques':
    case 'leadEddyProprietaire':
    case 'leadAssuranceEmprunteur':
    case 'leadAssuranceEmprunteurMeilleurTaux':
    case 'leadBankPanorabanques':
      return <IconCarbonFinance size={size} color={color} overrides={overrides} />
    case 'sales-leadMonConseillerPerso':
    case 'saleSelectraService':
    case 'leadMonConseillerPerso':
      return <IconCarbonMonConseillerPerso color={color} size={size} overrides={overrides} />
    case 'sales-leadGroupPurchaseTelecom':
    case 'leadGroupPurchaseTelecom':
      return <IconCarbonEventsAlt color={color} size={size} overrides={overrides} />
    case 'sales-leadMesAllocs':
    case 'leadMesAllocs':
    case 'saleAdministrativeService':
      return <IconCustomMesAllocs size={size} color={color} overrides={overrides} />
    case 'sales-leadWater':
    case 'leadWater':
      return <IconCarbonWater size={size} color={color} overrides={overrides} />
    case 'sales-leadProxiserve':
    case 'sales-leadBoilerEneco':
    case 'sales-leadBoilerEngie':
    case 'sales-leadBoilerHomeserve':
    case 'leadProxiserve':
    case 'leadBoilerEneco':
    case 'leadBoilerEngie':
    case 'leadBoilerHomeserve':
      return <IconCarbonToolKit size={size} color={color} overrides={overrides} />
    case 'sales-leadPartnership':
    case 'leadPartnership':
      return <IconCarbonTwoPersonLift size={size} color={color} overrides={overrides} />
    case 'sales-leadMovingNextories':
    case 'leadMovingNextories':
      return <IconCustomNextories color={color} size={size} overrides={overrides} />
    case 'sales-leadRetentionVa':
    case 'leadRetentionVa':
      return <IconCustomRetentionVa color={color} size={size} overrides={overrides} />
    case 'sales-leadVerisureTelecom':
    case 'sales-leadVerisureTelecomBe':
    case 'sales-leadVerisure':
    case 'leadVerisureTelecom':
    case 'leadVerisureTelecomBe':
    case 'leadVerisure':
      return <IconCarbonNotification size={size} color={color} overrides={overrides} />
    case 'sales-accessoriesSfr':
    case 'leadAccessoriesSfr':
      return <IconCarbonHeadphones size={size} color={color} overrides={overrides} />
    case 'sales-leadFloraAssurance':
    case 'leadFloraAssurance':
    case 'sales-leadFloraAssuranceEthias':
    case 'leadFloraAssuranceEthias':
    case 'sales-leadFloraAssuranceLead':
    case 'leadFloraAssuranceLead':
      return <IconCarbonHome size={size} color={color} overrides={overrides} />
    case 'sales-leadSantevetAssurance':
    case 'leadSantevetAssurance':
      return <IconCarbonAirlinePassengerCare size={size} color={color} overrides={overrides} />
    case 'sales-leadElite':
    case 'leadElite':
      return <IconCarbonBadge size={size} color={color} overrides={overrides} />
    case 'sales-leadHomyos':
    case 'leadHomyos':
      return <IconCustomHomyos size={30} color={color} overrides={overrides} />
    case 'info-telecom-sale':
      return <IconPhone size={size} overrides={overrides} />
    case 'info-energy-sale':
      return <IconBolt size={size} overrides={overrides} />
    case 'info-insurance-sale':
      return <IconShieldPerson size={size} overrides={overrides} />
    case 'sales-leadEmoovz':
    case 'leadEmoovz':
      return <IconCustomEmoovz size={size} color={color} overrides={overrides} />
    default:
      return <IconCarbonInformation size={size} color={color} overrides={overrides} />
  }
}

export default retrieveAdditionalSalesIcons
